import React from 'react';
import Verify from '../components/Verify/index';
import VERIFICATION_TYPES from '../types';

const VerifyEmail = () => <Verify type={VERIFICATION_TYPES.EMAIL} />;

export default VerifyEmail;
